import { useTranslation } from "react-i18next";
import AppConfigContext from "../../context/AppConfigContext";
import { useContext } from "react";

const FormHeader = ({ step }) => {
    const { config } = useContext(AppConfigContext)
    const { t } = useTranslation(config.theme, { keyPrefix: "header" });

    if (step !== 1) {
        return <></>;
    }

    return (
        <div className="bg-primary px-4 pb-3 text-white">
            <p>{t("content1")}</p>
            <ul>
                <li>{t("list1")}</li>
                <li>{t("list2")}</li>
                <li>{t("list3")}</li>
            </ul>
            <p>{t("content2")}</p>
            <p>{t("content3")}</p>
        </div>
    );
};

export default FormHeader;
